var axios = require('axios')
var to = require('await-to-js').default
//TODO: Store these in SECURE place!!
//TODO: these functions will be moved to a seperate Auth service
var refreshToken_ = 'REDACTED'
var key = 'AIzaSyDAgk5rTxrLsyOpNE_ngYPxP55iE4-EAGs'
var jwt = require('jsonwebtoken');
const firebaseConfig = require('../../config/firebase')
//var serviceAccount = require("C:/Users/Houst/Downloads/curatedcrasheasymobileapp-67a474651a19.json");
var FormData = require('form-data');
const env = process.env.NODE_ENV

var XMLHttpRequest = require("xmlhttprequest").XMLHttpRequest;
let hostName; 
if (env === "development"){
	hostName = "http://localhost:8080"
}
else if(env === "production"){
	hostName = firebaseConfig.firebaseFunctionsHostURL
}

const getAccessTokenFromRefreshToken = async function(refreshToken){
  //remove
  if(!refreshToken||refreshToken === null){
    refreshToken = refreshToken_
  }
  const url = 'https://securetoken.googleapis.com/v1/token?key=' + key
  return await(axios.post(url, 
    {
      grant_type: "refresh_token",
      refresh_token: refreshToken
    }))
}

const getStreetAddressFrom = async function(lat, long) {
  try {
    var { data } = await axios.get(
      "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
        lat +
        "," +
        long +
        "&key={yourAPIKey}"
    );
    if(data.error_message) {
      console.log(data.error_message)
    } else {
      this.address = data.results[0].formatted_address;
    }
  } catch (error) {
    console.log(error.message);
  } 
}

async function sendMessage(headers_obj, message, callback)
{
 const token = headers_obj.userToken 
  var form = new FormData()
form.append("message", headers_obj.Message)
form.append("To", headers_obj.To)
form.append("subject", headers_obj.Subject)
form.append("messageText", headers_obj.MessageText)
form.append("userToken", token)
  // var email = '';

  // for(var header in headers_obj)
  //   email += header += ": "+headers_obj[header]+"\r\n";

  // email += "\r\n" + message;
  // const [sendErr, sendRes] = await to( axios.post(hostName + "/sendEmail", form));

  // if(sendErr){
  //   throw sendErr
  // }

  // return sendRes
  
return(await( axios.post(hostName + "/sendEmail", form)))
  //return sendRequest.execute(callback);
}


    
module.exports = {getAccessTokenFromRefreshToken, getStreetAddressFrom, sendMessage}


// WEBPACK FOOTER //
// ./src/services/google.js